module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_119-e13fbb8484202692e60a1c5d7f5d2914.png";